import {TerminalIcon, CommentDiscussionIcon, PeopleIcon, ToolsIcon, FileIcon, InfoIcon} from '@primer/octicons-react'
import type {NudgeDefinition} from '../types/nudge'

export const NUDGE_DISMISS_PREFIX = 'mc_nudge_'

export const nudgeRegistry: NudgeDefinition[] = [
  // ─── Agents tab: Sequential CTAs ───
  {
    id: 'download_cli',
    placement: 'agents_tab_below_input',
    variant: 'cta',
    title: 'Copilot CLI',
    description: 'Start coding agent sessions right from your terminal.',
    icon: TerminalIcon,
    actions: [{label: 'Download', href: 'https://cli.github.com', variant: 'primary', external: true}],
    dismissKey: `${NUDGE_DISMISS_PREFIX}download_cli`,
    priority: 100,
  },
  {
    id: 'download_slack',
    placement: 'agents_tab_below_input',
    variant: 'cta',
    title: 'Get Copilot in Slack',
    description: 'Start coding agent tasks directly from Slack conversations.',
    icon: CommentDiscussionIcon,
    actions: [
      {label: 'Set up Slack', href: 'https://github.com/marketplace/slack-github', variant: 'primary', external: true},
    ],
    dismissKey: `${NUDGE_DISMISS_PREFIX}download_slack`,
    priority: 90,
  },
  {
    id: 'download_teams',
    placement: 'agents_tab_below_input',
    variant: 'cta',
    title: 'Get Copilot in Teams',
    description: 'Kick off coding agent tasks from Microsoft Teams.',
    icon: PeopleIcon,
    actions: [
      {
        label: 'Set up Teams',
        href: 'https://github.com/marketplace/microsoft-teams-for-github',
        variant: 'primary',
        external: true,
      },
    ],
    dismissKey: `${NUDGE_DISMISS_PREFIX}download_teams`,
    priority: 80,
  },

  // ─── Agents tab: agents.md nudge ───
  {
    id: 'setup_agents_md',
    placement: 'agents_tab_below_input',
    variant: 'tip',
    title: 'Customize Copilot with agents.md',
    description:
      'Add a .github/agents.md file to give Copilot context about your repo — coding standards, architecture, and preferred patterns.',
    icon: FileIcon,
    actions: [
      {
        label: 'Learn how',
        href: 'https://docs.github.com/en/copilot/customizing-copilot/adding-custom-instructions-for-github-copilot',
        variant: 'primary',
        external: true,
      },
    ],
    dismissKey: `${NUDGE_DISMISS_PREFIX}setup_agents_md`,
    condition: ctx => !ctx.hasAgentsMd,
    priority: 110,
  },

  // ─── Task view: Inline tips for active tasks ───
  // (Removed: per-session content-area nudges conflict with icebreakers and other inline UI.
  // Nudges now live only in the sidebar / dedicated nudge placements.)

  // ─── Agents tab: Automations announcement ───
  {
    id: 'automations_launched',
    placement: 'agents_tab_below_input',
    variant: 'feature_announcement',
    title: 'Automations',
    description:
      'Start agent sessions automatically on a schedule or in response to events like new issues or updated pull requests.',
    icon: InfoIcon,
    actions: [
      {
        label: 'Learn more',
        href: 'https://gh.io/cca-automations-docs',
        variant: 'primary',
        external: true,
      },
    ],
    dismissKey: `${NUDGE_DISMISS_PREFIX}automations_launched`,
    priority: 120,
  },

  // ─── MCP settings: Discovery nudge ───
  {
    id: 'mcp_getting_started',
    placement: 'mcp_settings_discovery',
    variant: 'info',
    title: 'Connect Copilot to external tools with MCP',
    description: 'MCP servers let Copilot interact with databases, APIs, and other developer tools during tasks.',
    icon: ToolsIcon,
    actions: [
      {
        label: 'Browse MCP servers',
        href: 'https://github.com/modelcontextprotocol/servers',
        variant: 'primary',
        external: true,
      },
      {
        label: 'Configuration guide',
        href: 'https://docs.github.com/en/copilot/customizing-copilot/extending-the-capabilities-of-github-copilot-in-your-organization',
        variant: 'link',
        external: true,
      },
    ],
    dismissKey: `${NUDGE_DISMISS_PREFIX}mcp_getting_started`,
    priority: 100,
  },
]

export const loadingStateTips = [
  {title: 'Try asking Copilot to plan before implementing'},
  {title: 'Reference specific files to give Copilot better context'},
  {title: 'You can ask Copilot to explain its approach before making changes'},
  {title: 'Add a .github/agents.md file to customize Copilot for your repository'},
  {title: 'Copilot can work on multiple tasks in parallel across different repos'},
  {title: 'Use the Copilot CLI to start tasks from your terminal'},
  {title: 'Ask Copilot to write tests for its own changes before finishing'},
  {title: "You can approve or reject Copilot's plan before it starts coding"},
]
